<template>
    <div class="arbitration">
      <div class="arbitration-content">
      <div class="arbitration-title">
        <div v-if="status===32" class="medium">Brand:{{message.brandName}}</div>
        <div v-if="status===33" class="medium">Platform Arbitration</div>
        <div v-if="status!==32" class="medium">{{message.username}}</div>
        <div>{{message.createAt}}</div>
      </div>
      <div class="arbitration-text">
        <div v-if="status===3||status===30">The Retailer ({{message.username}})  Arbitration initiated</div>
        <div v-if="status===33">The platfrom (ShopVidi)  complete arbitration</div>
        <div v-if="status===33">
          Arbitration result:
          <span v-if="serviceOrderMessage['refundUndertaker']===1">Brand commitment</span>
          <span v-else-if="serviceOrderMessage['refundUndertaker']===2">Platfrom commitment</span>
          <span v-else>Retailer commitment</span>
        </div>
        <div  v-if="status===31||status===32">Submit Arbitration Information</div>
        <div>Arbitration reason:{{message.reason}}</div>
      </div>
      <div class="arbitration-swiper" :key="Math.random().toString(16).slice(2)">
        <img-swiper :edit="false" :imgListMessage="imgListMessage" v-if="JSON.stringify(imgListMessage)!=={}"></img-swiper>
      </div>
          </div>
    </div>
</template>

<script>
import imgSwiper from '../img-swiper.vue'
export default {
  props: {
    message: {
      default: () => { return {} },
      type: Object
    },
    serviceOrderMessage:{
      default: () => { return {} },
      type: Object
    },
    status: {
      default: 0,
      type: Number
    }
  },
  components: {
    imgSwiper
  },

  data() {
    return {
      imgListMessage: []
    }
  },
  created() {
    // this.message
    this.imgListMessage = this.message['serviceOrderFeedbackPicList'].map((e, i) => {
      return e.img
    })
  },
  watch: {
    'message': {
      handler(newVal, oldVal) {
        this.imgListMessage = newVal['serviceOrderFeedbackPicList'].map((e, i) => {
          return e.img
        })
      },
      deep: true,
      immediate: true
    }

  }
}
</script>

<style lang="less" scoped>
.arbitration{
  padding: 0 20px;
}
.arbitration-content{
  padding-bottom: 20px;
  border-bottom: 1px solid #E1E1E1;
}
.arbitration-swiper{
  margin-top: 20px;
}
.arbitration-text{
  line-height: 32px;
}
.arbitration-title{
  padding-top: 20px;
  display: flex;
  justify-content: space-between;
  div:nth-child(2){
    font-family: Satoshi !important;
  }
}
.medium{
  font-family: Satoshi-medium;
}
</style>



// WEBPACK FOOTER //
// src/pages/order/service-order/components/history-list/arbitration.vue